import { ContactDetailsForm } from "./Form";
import { useContactDetails } from "./hooks/useContactDetails";

export const ContactDetails = () => {
  const props = useContactDetails();
  return <ContactDetailsForm {...props} />;
};

export default ContactDetails;
